<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->
            <refresh-button @refresh="refreshTable()"></refresh-button>
            <!-- <add-button v-if="$moduleAccess('add_employee')" @add="openAddDialog"></add-button> -->
            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <!-- Insert View Dialog Content BELOW-->

                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :userData="viewUser"
                      :accessCards="accessCards"
                      :readonly="dialogType === 'view'"
                      hidePassword
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <customize-dialog
              :action="dialogType"
              :title="title"
              color="teal"
              showSave
              :dialog="settingDialog"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md12>
                    <!-- Insert View Dialog Content BELOW-->
                    <settings-container
                      ref="settingsRef"
                      :data="viewData"
                      :subcompanies="subcompanies"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </customize-dialog>

            <v-dialog v-model="assignDialog" scrollable max-width="300px">
              <v-card>
                <v-card-title>Select Role</v-card-title>

                <v-divider></v-divider>

                <v-card-text style="height: 300px">
                  <v-radio-group v-model="role" column>
                    <v-radio
                      v-for="(vehicle, v) in rolesItems"
                      :key="v"
                      color="primary"
                      :label="vehicle.text"
                      :value="vehicle.value"
                    ></v-radio>
                  </v-radio-group>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" flat @click="closeAssignDialog()"
                    >Close</v-btn
                  >
                  <v-btn
                    color="primary"
                    flat
                    :disabled="role === null || role === viewData.role_id"
                    @click="saveAssignDialog()"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <delete-dialog
              :title="title"
              :type="deleteType"
              :deleteDialog="deleteDialog"
              @saveDeleteDialog="saveDeleteDialog"
              @closeDeleteDialog="closeDeleteDialog"
              :loading="confirmLoading"
            ></delete-dialog>
            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'edit'
                  ? saveEditDialog()
                  : dialogType === 'add'
                  ? saveConfirmedAddDialog()
                  : dialogType === 'assign'
                  ? saveConfirmedSubscribeDialog()
                  : dialogType === 'settings'
                  ? saveSettingsDialog()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <!-- <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">
                    {{
                    openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>-->
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterPosition"
                :items="filterPositions"
                label="Position"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  {{ header.text.toUpperCase() }}
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.code }}</td>
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>

                <setting-button
                  v-if="$moduleAccess('settings_sub_company')"
                  @setting="openSettingsDialog(props.item)"
                ></setting-button>

                <manage-button
                  v-if="$store.state.sub_company_menu.length"
                  @manage="manageCompany(props.item)"
                ></manage-button>

                <manage-button
                  v-if="props.item.menu"
                  @manage="manageSubCompany(props.item)"
                ></manage-button>

                <!-- <edit-button @edit="openEditDialog(props.item)"></edit-button> -->
                <!-- <assign-button title="Assign to Project" @assign="openSubscribeDialog(props.item)"></assign-button> -->
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/CompanyServices";
import MainServices from "@/services/Services";
import DetailsContainer from "@/components/details_container/CompanyDetailsContainer";
import SettingsContainer from "@/components/details_container/SettingsDetailsContainer";

export default {
  components: {
    DetailsContainer,
    SettingsContainer,
  },
  data() {
    return {
      rolesItems: [],
      openFilter: false,
      filterPositions: [],
      filterPosition: "",

      title: "Sub Company",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Code",
          align: "left",
          value: "code",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      items: [],
      employeeItems: [],
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        company_id: null,
        sub_company_id: null,
      },
      dialogType: "",
      dialogStatus: false,
      settingDialog: false,
      openConfirmDialog: false,
      viewData: {},
      viewUser: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
      ],
      selected: [],
      addDialog: false,

      subscribeDialog: false,
      assignItems: [],
      positions: [
        {
          text: "FC SUPPORT",
          value: "fc support",
        },
        {
          text: "HEAD SUPPORT",
          value: "head support",
        },
      ],
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
      },
      accessCards: [],
      vehicles: [],
      subcompanies: [],
      role: null,
      assignDialog: false,
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data

        this.queryParams.company_id = this.$store.state.company.id;

        let response = (await Services.getCompanies(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async getProjects() {
      // Start Loading
      this.assignItems = [];
      this.assignItems = response.projects;
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getCompany(id);
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      return data;
    },
    async setManageCompany(id) {
      var data = {};

      try {
        const response = await Services.getManageCompany(id);
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      return data;
    },
    async setSettings(id) {
      var data = {};

      try {
        const response = await Services.getCompanySettings(id);
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      return data;
    },
    async setUser(id) {
      var data = {};

      try {
        const response = await Services.getUser(id);
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      return data;
    },
    async setEmployees() {
      this.employeeItems = [];
      this.employeeItems = (
        await Services.getUnassignedEmployees({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
        })
      ).data;
    },

    async setRoles() {
      let items;

      try {
        items = (
          await Services.getRoles({
            company_id: this.$store.state.company.id,
            sub_company_id: this.$store.state.subcompany.id,
          })
        ).data.data;
        this.rolesItems = await Promise.all(
          items.map(async (item) => {
            const id = item.id;
            const name = item.name.toUpperCase();

            return {
              value: id,
              text: name,
            };
          })
        );
      } catch (error) {
        console.log(error);
      }
    },

    async setAccessCards() {
      this.accessCards = [];

      const response = await Services.getAccessCard(
        this.viewData.access_card_id
      );
      const data = await response.data;

      this.accessCards.push({
        text: data.embedded_id.toUpperCase(),
        value: data.id,
      });
    },
    async setSubCompaniesSettings() {
      this.subcompanies = [];

      const items = (await MainServices.getSubCompanies({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: `${el[i].name.toUpperCase()}  ${
            el[i].company ? " | " + el[i].company.name.toUpperCase() : ""
          }`,
          value: el[i].id,
        };
        this.subcompanies.push(data);
      }
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.addDialog = true;

      this.setEmployees();
      this.setRoles();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openSettingsDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "settings";

      this.settingDialog = true;

      await this.setSubCompaniesSettings();

      this.viewData = await this.setSettings(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);
      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },

    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }

      if (this.$refs.settingsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      if (this.$refs.form.validate()) {
        this.openConfirmDialog = true;
      }
    },
    async saveConfirmedAddDialog() {
      console.log(this.selected);

      this.confirmLoading = true;

      const employees = this.selected.map((employee) => {
        return {
          id: employee.id,
          role_id: employee.role,
        };
      });
      const body = {
        employees: employees,
        company_id: this.$store.state.company.id,
        sub_company_id: this.$store.state.subcompany.id,
      };
      try {
        console.log(body);

        const response = await Services.assignEmployees(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAddDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Employee(s) has been added",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          id: data.id,
          first_name: data.first_name,
          middle_name: data.middle_name,
          last_name: data.last_name,
          email: data.email,
          gender: data.gender,
          nationality: data.nationality,
          birth_date: data.birth_date,
          civil_status: data.civil_status,
          unit_no: data.unit_no,
          house_no: data.house_no,
          street: data.street,
          subdivision: data.subdivision,
          barangay: data.barangay,
          city: data.city,
          province: data.province,
          zip_code: data.zip_code,
          issued_company_id: data.issued_company_id,
          access_card_id: data.access_card_id,
        };
      try {
        const response = await Services.editEmployee(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Employee has been updated!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveSettingsDialog() {
      this.confirmLoading = true;

      const data = this.$refs.settingsRef.computedData,
      body = {
          dormant_fee: data.dormant_fee,
          dormant_duration: data.dormant_duration,
          denomination_list: data.denomination_list,
          load_print_status: data.load_print_status,
          command_source: data.command_source,
          sync_deadline: `${data.sync_day} ${data.sync_hour} ${data.sync_minute}`,
          transfer_fee_amount: data.transfer_fee_amount,
          card_replacement_price_list: data.card_replacement_price_list
        };
      try {
        // if (body.agent_reservation) {
        //   if (!body.client_sub_companies.length) {
        //     this.confirmLoading = false;
        //     this.openConfirmDialog = false;

        //     return this.$infoBar({
        //       type: "error",
        //       text: "No selected sub-company",
        //     });
        //   }
        // }

        const response = await Services.editCompanySettings(data.id, body);

        this.closeDialog();
        await this.getData();
        this.$infoBar({
          type: "success",
          text: "Settings has been updated!",
        });
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteEmployee(this.viewData.id);

        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();

          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Employee has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }

      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      this.subcompanies = [];

      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
      this.settingDialog = false;
    },
    closeAddDialog() {
      console.log(this.selected);
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.employeeItems.slice();
    },
    async openSubscribeDialog(data) {
      this.dialogLoading = true;
      this.dialogType = "assign";
      this.subscribeDialog = true;
      this.viewData = data;

      this.viewData = await this.setData(data.id);
      this.assignedItems = await this.viewData.projects;
      await this.getProjects();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async closeSubscribeDialog() {
      this.selected = [];
      this.viewData = {};
      this.closeConfirmDialog();
      this.dialogType = "";
      this.subscribeDialog = false;
    },
    saveSubscribeDialog() {
      this.openConfirmDialog = true;
    },
    notSubscribe(data) {
      for (var e = 0; e < this.assignedItems.length; e++) {
        if (this.assignedItems[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    showSubcribe(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          return false;
        }
      }
      return true;
    },
    subscribeToProject(data) {
      this.selected.push(data);
    },
    unsubscribeToProject(data) {
      for (var e = 0; e < this.selected.length; e++) {
        if (this.selected[e].id === data.id) {
          this.selected.splice(e, 1);
        }
      }
    },
    async saveConfirmedSubscribeDialog() {
      this.confirmLoading = true;

      const projects = this.selected.map((project) => {
        return {
          id: project.id,
          position: project.SubCompanyProject.position,
        };
      });
      const body = {
        projects: projects,
        employee_id: this.viewData.id,
      };
      try {
        const response = await Services.assignEmployeetoProject(body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeSubscribeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Project/s has been assigned to Employee!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    async refreshTable() {
      this.$refs.searchRef.clear();
      this.filterPosition = await null;
      await this.getData();
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterPosition();
    },
    async setFilterPosition() {
      const items = (
        await Services.getEmployees({
          limit: this.items.count,
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
          project_id: this.$store.state.project.id,
        })
      ).data.data;

      let toPush = [];

      items.forEach((item1) => {
        item1.projects.forEach((item2) => {
          toPush.push(item2.ProjectEmployee.position);
        });
      });

      let unique = [...new Set(toPush)];

      unique.forEach((position) => {
        let body = {
          text: position.toUpperCase(),
          value: position.toUpperCase(),
        };
        this.filterPositions.push(body);
      });
    },
    async openAssignDialog(data) {
      this.dialogType = "assign";

      await this.setRoles();

      this.role = data.role_id;

      this.viewData = await data;

      this.assignDialog = true;
    },
    async saveAssignDialog() {
      const body = {
        role_id: this.role,
      };

      try {
        const response = await Services.changeEmployeeAssignedRole(
          this.viewData.id,
          body
        );

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeAssignDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Role has been change!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
    },
    closeAssignDialog() {
      this.role = null;
      this.assignDialog = false;
    },
    async manageCompany(data) {
      try {
        if (this.$store.state.sub_company_menu.length) {
          let manage = await this.setManageCompany(data.id);

          this.$store.dispatch(
            "dispatchMenu",
            this.$store.state.sub_company_menu
          );

          this.$store.dispatch("dispatchSubCompany", {
            id: manage.id,
            name: manage.name,
            code: manage.code,
            conductor_status: manage.conductor_status,
            dispatcher_status: manage.dispatcher_status,
            vehicle_category: manage.vehicle_category,
            reservation_status: manage.reservation_status,
            baggage_status: manage.baggage_status,
          });

          this.$router.push({
            path: this.$store.state.sub_company_menu[0].link,
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "No Access",
          });
        }
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }
    },
    async manageSubCompany(data) {
      try {
        if (data.menu.length) {
          let manage = await this.setManageCompany(data.id);

          this.$store.dispatch("dispatchMenu", data.menu);
          this.$store.dispatch("dispatchSubCompany", {
            id: manage.id,
            name: manage.name,
            code: manage.code,
            conductor_status: manage.conductor_status,
            dispatcher_status: manage.dispatcher_status,
            vehicle_category: manage.vehicle_category,
            reservation_status: manage.reservation_status,
            baggage_status: manage.baggage_status,
          });

          this.$router.push({
            path: data.menu[0].link,
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "No Access",
          });
        }
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
